var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.176,20.075h-5.453v3.238h1.099v11.614h-1.099v3.238h6.555v-3.238h-1.102   V20.075z M50,25C50,11.193,38.807,0,25,0S0,11.193,0,25c0,13.807,11.193,25,25,25S50,38.807,50,25z M25,2.83   c12.246,0,22.17,9.924,22.17,22.17c0,12.246-9.924,22.17-22.17,22.17S2.83,37.246,2.83,25C2.83,12.754,12.754,2.83,25,2.83z    M22.474,14.363c0,1.394,1.131,2.524,2.526,2.524c1.393,0,2.524-1.13,2.524-2.524c0-1.395-1.131-2.526-2.524-2.526   C23.605,11.836,22.474,12.967,22.474,14.363z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.bc4e7de5fdda5cb7184ab999fa424c89.svg";
export { ForwardRef as ReactComponent };